import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface TableCartContextType {
  localTableCarts: Record<string, any[]>;
  addToCart: (tableId: string, product: any) => void;
  removeFromCart: (tableId: string, productId: string) => void;
  clearCart: (tableId: string) => void;
}

const TableCartContext = createContext<TableCartContextType | undefined>(undefined);

export const TableCartProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [localTableCarts, setLocalTableCarts] = useState<Record<string, any[]>>({});

  const addToCart = (tableId: string, product: any) => {
    setLocalTableCarts(prev => ({
      ...prev,
      [tableId]: [...(prev[tableId] || []), product]
    }));
  };

  const removeFromCart = (tableId: string, productId: string) => {
    setLocalTableCarts(prev => ({
      ...prev,
      [tableId]: (prev[tableId] || []).filter(item => item.id !== productId)
    }));
  };

  const clearCart = (tableId: string) => {
    setLocalTableCarts(prev => ({
      ...prev,
      [tableId]: []
    }));
  };

  return (
    <TableCartContext.Provider value={{ localTableCarts, addToCart, removeFromCart, clearCart }}>
      {children}
    </TableCartContext.Provider>
  );
};

export const useTableCart = () => {
  const context = useContext(TableCartContext);
  if (!context) {
    throw new Error('useTableCart must be used within a TableCartProvider');
  }
  return context;
};
